import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SectionTab from 'constants/SectionTab';
import ListItemList from '../ListItemList';
import { ListViewSkeleton } from 'common/ui/skeleton-ui';
import { scrollToMainContent } from 'common/ui/utils';
// import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  emptytext: {
    textAlign: 'center',
    width: '100%',
    position: 'relative',
    paddingBottom: theme.spacing(1),
    fontFamily: theme.typography.fontFamily
  },
  nodatalink: {
    color: 'rgb(255, 0, 102)',
    cursor: 'pointer'
  },
  description: {
    position: 'relative',
    marginBottom: 20
  }
}));

const popularList = (props, loading) => {
  const {
    mostPopular,
    podcasts,
    onListItemClick,
    onDeleteClick,
    onFavouriteClick,
  } = props;

  if (loading) {
    return [...Array(3)].map((_, idx) => {
      return <ListViewSkeleton key={idx} />;
    });
  }

  return mostPopular.slice(0, 3).map((id, index) => {
    return (
      <ListItemList
        key={index}
        sectionTab={SectionTab.PodCastDetail}
        podcastid={podcasts[id].id}
        image={podcasts[id].image ?? podcasts[id].artworkUrl600 ?? podcasts[id].artworkUrl100 ?? 'null'}
        title={podcasts[id].title ?? podcasts[id].name}
        subtitle={podcasts[id].country ?? podcasts[id].releaseDate ?? podcasts[id].language}
        data={podcasts[id]}
        onListItemClick={onListItemClick}
        onDeleteClick={onDeleteClick}
        onFavouriteClick={onFavouriteClick}
      />
    );
  });
};

const NoData = (props) => {
  const classes = useStyles();
  const { loading, message } = props;

  const onListItemClick = () => {
    props.onSetCurrentTab(SectionTab.PodCastPopular);
    scrollToMainContent();
  };

  return (
    <>
      <div className={classes.emptytext}>
        {message} Listen to some{' '}
        <span className={classes.nodatalink} onClick={onListItemClick}>popular podcasts</span>.
      </div>
      {/*{loading && (
        <div className={classes.description}>
          <CircularProgress color="primary" />
        </div>
      )}*/}
      {popularList(props, loading)}
    </>
  );
};

export default NoData;
